import { useLocation } from "react-router-dom";

/**
 * AWS環境かつチャット画面かどうか判定
 * @returns {boolean} AWS環境かつチャット画面の場合はtrue、それ以外はfalse
 */
export function useIsAwsChatPage(): boolean {
  const location = useLocation();
  const isAwsEnv = process.env.REACT_APP_SYSTEM_REQUIREMENT === "aws";
  const isChatPage = location.pathname === "/chat";
  return isAwsEnv && isChatPage;
}

/**
 * AWS環境かつWeb管理画面かどうか判定
 * @returns {boolean} AWS環境かつWeb管理画面の場合はtrue、それ以外はfalse
 */
export function useIsAwsSettingPage(): boolean {
  const location = useLocation();
  const isAwsEnv = process.env.REACT_APP_SYSTEM_REQUIREMENT === "aws";
  const isSettingPage = location.pathname === "/setting";
  return isAwsEnv && isSettingPage;
}

/**
 * 管理画面かどうか判定
 * @returns {boolean} 管理画面の場合はtrue、それ以外はfalse
 */
export function useIsSettingPage(): boolean {
  const location = useLocation();
  const isSettingPage = location.pathname === "/setting";
  return isSettingPage;
}
